import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

@Injectable({
	providedIn: 'root'
})
export class DashboardService {

	constructor(
		private http: HttpClient
	) { }

	getDashboardToken(companyId: string, projectId: string, email: string, procoreUserId: string, isSandbox: boolean, applicationType: string) {
		let params = new HttpParams();
		params = params.set('companyId', companyId);
		params = params.set('projectId', projectId);
		params = params.set('email', email);
		params = params.set('procoreUserId', procoreUserId);
		params = params.set('isSandbox', isSandbox);
		params = params.set('applicationType', applicationType);

		return this.http.get(`${environment.serviceUrl}/dashboard/token`, { params, responseType: 'text' });
	}

	getDashboardClientDetailProcore(uuid: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'plain/text');

		let params = new HttpParams();
		params = params.set('uuid', uuid);

		return this.http.get<any>(`${environment.serviceUrl}/dashboard/procore`, { headers, params });
	}

	getDashboardProjects(uuid: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('uuid', uuid);

		const requestUrl = `${environment.serviceUrl}/dashboard/projects`;

		return this.http.get<any>(requestUrl, { headers, params });
	}

	getDashboardSignatures(uuid: string, startPosition: number, status: string, project: string, mode: string, sortBy: string, sortOrder: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('uuid', uuid);
		params = params.set('startPosition', startPosition);
		params = params.set('status', status);
		params = params.set('project', project);
		params = params.set('mode', mode);
		params = params.set('sortBy', sortBy); // signatureCompleteDate or signatureRequestDate
		params = params.set('sortOrder', sortOrder); // asc or desc

		const requestUrl = `${environment.serviceUrl}/dashboard/signatures`;

		return this.http.get<any>(requestUrl, { headers, params });
	}

	getDashboardReminderEmail(uuid: string, signatureRequestId: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('uuid', uuid);
		params = params.set('signatureRequestId', signatureRequestId);
		params = params.set('applicationType', "DBS for Procore");

		const requestUrl = `${environment.serviceUrl}/dashboard/reminder/email`;

		return this.http.get<any>(requestUrl, { headers, params });
	}


	sendDashboardReminder(uuid: string, signatureRequestId: string, signerEmail: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('uuid', uuid);
		params = params.set('signatureRequestId', signatureRequestId);
		params = params.set('signerEmail', signerEmail);

		const requestUrl = `${environment.serviceUrl}/dashboard/reminder`;

		return this.http.post<any>(requestUrl, null, { headers, params });
	}

	getDashboardSignatureDownloadStream(uuid: string, signatureRequestId: string, filename: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/pdf');

		let params = new HttpParams();
		params = params.set('uuid', uuid);
		params = params.set('signatureRequestId', signatureRequestId);
		params = params.set('filename', filename);

		const requestUrl = `${environment.serviceUrl}/dashboard/stream`;

		return this.http.get(requestUrl, { headers, params, responseType: 'blob' });
	}
}
